import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthType from "./authentication/authType";
import AdminLogin from "./authentication/adminLogin";
import AdminRegister from "./authentication/adminRegister";
import AdminDashboard from "./adminPages/adminDashboard";
import AllVehicleList from "./adminPages/allVehicleList";
import UserLogin from "./authentication/userLogin";
import Reports from "./adminPages/reportsPage";
import VehicleEntry from "./adminPages/vehicleEntry";
import EditSlots from "./adminPages/slotsedit";
import HourlyUserList from "./userList/hourlyUserList";
import HourlyUserDetail from "./userList/hourlyUserDetail";
import MonthlyUserList from "./userList/monthlyUserList";
import MonthlyUserDetail from "./userList/monthlyUserDetail";
import DayUserList from "./userList/dayUserList";
import DayUserDetails from "./userList/dayuserDetail";
import PrivateRoute from "./components/privateRoute"; // Import PrivateRoute
import UserPrivateRoute from "./components/userPrivateRoute";
// user dashboard pages
import UserDashoard from "./userDashboard/dashboard";
import UserVehicleDetails from "./userDashboard/vehicleDetail";
import UserReports from "./userDashboard/reports";
import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuthType />} />
          <Route path="/adminLogin" element={<AdminLogin />} />
          <Route path="/adminRegister" element={<AdminRegister />} />
          <Route path="/userLogin" element={<UserLogin />} />

          {/* Protect Admin Dashboard using PrivateRoute */}
          <Route element={<PrivateRoute />}>
            <Route path="/adminDashboard" element={<AdminDashboard />}>
              <Route index element={<Reports />} />
              <Route path="vehicleEntry" element={<VehicleEntry />} />
              <Route path="editSlots" element={<EditSlots />} />
              <Route path="allVehicleList" element={<AllVehicleList />} />
              <Route path="hourlyParkingList" element={<HourlyUserList />} />
              <Route path="hourlyParkingUserDetail/:id" element={<HourlyUserDetail />} />
              <Route path="monthlyParkingList" element={<MonthlyUserList />} />
              <Route path="monthlyParkingUserDetail/:id" element={<MonthlyUserDetail />} />
              <Route path="dayParkingList" element={<DayUserList />} />
              <Route path="dayParkingUserDetail/:id" element={<DayUserDetails />} />
            </Route>
          </Route>
          <Route element={<UserPrivateRoute />}>
            <Route path="/userDashboard" element={<UserDashoard />}>
              <Route index element={<UserReports />} /> {/* default on /userDashboard */}
              <Route path="vehicleDetail/:id" element={<UserVehicleDetails />} /> {/* on /vehicleDetail/:id */}
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
